export interface ClickedUsageTracking {
  anonymousGuid?: string;
  currentUrl?: string;
  clickedElement?: string;
}
